import React from 'react'
import CreditCard from '../CreditCard'
import Carousel from 'react-multi-carousel';
import { useEffect } from 'react';
import { Col, Row } from 'react-bootstrap';
import { AiOutlinePlusCircle } from 'react-icons/ai';

import './index.css'

const responsive = {
  superLargeDesktop: {
    // the naming can be any, depends on you.
    breakpoint: { max: 4000, min: 3000 },
    items: 5
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 3
  },
  tablet: {
    breakpoint: { max: 1024, min: 770 },
    items: 1
  },
  mobile: {
    breakpoint: { max: 770, min: 0 },
    items: 1
  }
};

export default function CreditCardCarousel({ creditCard, openCreditCardModal }) {

  return (
    <div>
      {creditCard.length <= 1 ?
        <div className="row-align">
          <div onClick={() => openCreditCardModal(creditCard[0])}>
            <CreditCard creditCard={creditCard[0]} />
          </div>
          <div className="credit-card-add">
            <span>
              <AiOutlinePlusCircle size='4em' color="#35A0E6" />
            </span>
          </div>
        </div>
        :
        <Carousel
          responsive={responsive}
          infinite={true}
          draggable={true}
          itemClass="carousel-item-padding"
        >
          {creditCard.map((card) => (
            <div onClick={() => openCreditCardModal(card)}>
              <CreditCard creditCard={card} />
            </div>
          ))}
        </Carousel>
      }
    </div>
  )
}
